import { Card, CardBody, Col, Row } from "reactstrap";
import BorderedRadio from "./BorderedRadio";
import FilledRadio from "./FilledRadio";
import IconsRadio from "./IconsRadio";
import { CustomRadiosTitle } from "../../../../../../constants";
import { CustomRadioBoxSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const CustomRadio = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={CustomRadiosTitle} span={CustomRadioBoxSubTitle} />
        <CardBody>
          <Row className="g-3">
            <BorderedRadio />
            <IconsRadio />
            <FilledRadio />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CustomRadio;
